import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Circle from './Circle.js';
import SpinningCircle from './SpinningCircle.js';

var _ChartInfoPointsLegend;
var ChartInfoPointsLegend = withTheme((_ChartInfoPointsLegend = /*#__PURE__*/function (_Component) {
  function ChartInfoPointsLegend() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ChartInfoPointsLegend, _Component);
  var _proto = ChartInfoPointsLegend.prototype;
  _proto.render = function render() {
    var boxStyle = {
        position: 'absolute',
        top: '15px',
        right: '25px',
        maxWidth: '50%',
        backgroundColor: this.props.theme.constellation.colors.borderLight,
        border: "1px solid " + this.props.theme.constellation.colors.borderDark,
        textAlign: 'left',
        fontSize: '12px'
      },
      info = this.props.activeInfoPoint ? /*#__PURE__*/React.createElement("div", {
        style: boxStyle,
        className: "linechart-legend"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        style: {
          padding: '5px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "zsg-icon-circle",
        style: {
          paddingRight: '5px',
          color: this.props.activeInfoPoint.color,
          fontSize: '10px'
        }
      }), this.props.activeInfoPoint.info))))) : null;
    return info;
  };
  return ChartInfoPointsLegend;
}(Component), _ChartInfoPointsLegend.propTypes = {
  activeInfoPoint: PropTypes.object,
  color: PropTypes.string,
  theme: PropTypes.object
}, _ChartInfoPointsLegend));
var ChartInfoPoints = /*#__PURE__*/function (_Component2) {
  function ChartInfoPoints() {
    return _Component2.apply(this, arguments) || this;
  }
  _inheritsLoose(ChartInfoPoints, _Component2);
  var _proto2 = ChartInfoPoints.prototype;
  _proto2.render = function render() {
    var props = this.props,
      infoPointCircles = [];
    if (props.infoPoints) {
      props.infoPoints.forEach(function (point) {
        if (point.active) {
          infoPointCircles.push(/*#__PURE__*/React.createElement(SpinningCircle, {
            key: point.x + "info",
            cx: props.xScale(point.x),
            cy: props.yScale(point.y),
            r: 10,
            color: point.color
          }));
        }
        infoPointCircles.push(/*#__PURE__*/React.createElement(Circle, {
          key: point.x,
          cx: props.xScale(point.x),
          cy: props.yScale(point.y),
          r: 5,
          fill: point.color
        }));
      });
    }
    return /*#__PURE__*/React.createElement("g", null, infoPointCircles);
  };
  return ChartInfoPoints;
}(Component);
ChartInfoPoints.propTypes = process.env.NODE_ENV !== "production" ? {
  infoPoints: PropTypes.array,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  color: PropTypes.string
} : {};

export { ChartInfoPoints, ChartInfoPointsLegend };
